import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  MenuItem,
  Checkbox,
  Input,
  makeStyles,
} from '@material-ui/core';

import { uniqueId } from 'lodash';
import { externalContentActions } from '../../actions';
import { useDispatch } from 'react-redux';
import { useWindowSize } from '../../hooks';

import config from '../../config';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  title: {
    fontFamily: 'Poppins',
    color: theme.palette.neutrals.low.medium,
    fontWeight: 500,
    marginRight: 8,
  },
  formControl: {
    minWidth: 200,
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    maxWidth: '100%',
    backgroundColor: theme.palette.neutrals.high.medium,
    borderRadius: 4,
    paddingRight: 10,
    paddingLeft: 10,
    marginRight: 16,
    padding: theme.spacing(1.2, 2),
    maxHeight: 48,
  },
  select: {
    minWidth: 0,
  },
  icon: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

const filters = [
  { id: uniqueId, value: 'ACTIVE', name: 'Ativo' },
  { id: uniqueId, value: 'NOT_ACTIVE', name: 'Não Ativo' }
];

function ExternalContentFilter({ statusCode }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [width] = useWindowSize();
  const { t } = useTranslation();

  function handleChangeFilter(e) {
    dispatch(externalContentActions.toggleFilter(e.target.value));
  }

  function handleStatusToName(status) {
    switch (status) {
      case 'NOT_ACTIVE':
        return 'Não Ativo';

      case 'ACTIVE':
        return 'Ativo';

      default:
        return 'Todos';
    }
  }

  return (
    <div className={classes.container}>
      <span className={classes.title}>{t('visualizar')}:</span>
      <FormControl className={classes.formControl}>
        <Select
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          fullWidth
          value={statusCode}
          onChange={handleChangeFilter}
          input={<Input />}
          renderValue={(selected) => {
            if (width > config.RESPONSIVE_MOBILE) {
              return `${handleStatusToName(selected[0])} ${
                selected.length > 1 ? `+${selected.length - 1}` : ''
              }`;
            }
          }}
          displayEmpty
          classes={{
            select: classes.select,
            icon: classes.icon,
          }}
          MenuProps={MenuProps}
          disableUnderline
        >
          {filters.map((filter, index) => (
            <MenuItem key={index} value={filter.value}>
              <Checkbox
                color="primary"
                checked={statusCode.indexOf(filter.value) > -1}
              />
              <ListItemText primary={filter.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export { ExternalContentFilter };
